import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { CatalogAdjustmentReason } from "../models/CatalogAdjustmentReason";

export const getAdjustmentReasons = async (
	params: { adjustmentReasonId?: number | null },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	if (params.adjustmentReasonId)
		parameters.push({
			name: "AdjustmentReasonId",
			value: params.adjustmentReasonId,
		});

	const resp = await apiService.callV2(
		"[M2].[GetAdjustmentReasons]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as CatalogAdjustmentReason[];
	} else {
		throw new Error(resp.message || "Error fetching adjustment types");
	}
};
export const upsertAdjustmentReason = async (
	adjustmentReason: CatalogAdjustmentReason,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "AdjustmentReasonId", value: adjustmentReason.AdjustmentReasonId },
		{
			name: "AdjustmentReasonName",
			value: adjustmentReason.AdjustmentReasonName,
		},
	];

	const resp = await apiService.callV2(
		"[M2].[UpsertAdjustmentReason]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.returnValue", null) as number;
	} else {
		throw new Error(resp.message || "Error upserting adjustments reasons");
	}
};

export const deleteAdjustmentReason = async (
	adjustmentReasonId: number | null,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "AdjustmentReasonId", value: adjustmentReasonId },
	];

	const resp = await apiService.callV2(
		"[M2].[DeleteAdjustmentReason]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting adjustments reasons");
	}
};
